// extracted by mini-css-extract-plugin
export default {"message_templates_wrapper":"MessageTemplates_message_templates_wrapper__5YDh5","template":"MessageTemplates_template__enzUo","shimmer":"MessageTemplates_shimmer__20D9t"};